"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var AppCheckboxInput = /*#__PURE__*/function (_Component) {
  _inherits(AppCheckboxInput, _Component);

  function AppCheckboxInput(props) {
    var _this;

    _classCallCheck(this, AppCheckboxInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AppCheckboxInput).call(this, props));
    _this.state = {
      value: props.value
    };
    return _this;
  }
  /**
   * Toggle checkbox value
   */


  _createClass(AppCheckboxInput, [{
    key: "_toggleValue",
    value: function _toggleValue() {
      var _this2 = this;

      this.setState({
        value: !this.props.value
      }, function () {
        if (_this2.props.handler) {
          _this2.props.handler.handleInputChange(_this2.props.name, _this2.state.value);

          if (_this2.props.validateOnChange) {
            _this2.props.handler.validateField(_this2.props.name, _this2.state.value);
          }
        }

        _this2.props.onChange(_this2.state.value);
      });
    }
  }, {
    key: "getErrors",
    value: function getErrors() {
      var _this3 = this;

      if (this.props.hideValidationErrors) return null;
      var messages = [];
      this.props.handler.getErrors().filter(function (x) {
        return x.field === _this3.props.name;
      }).forEach(function (error) {
        return messages.push(error.message);
      });

      if (messages.length === 0) {
        return null;
      }

      return _react["default"].createElement("div", {
        className: "validation-message checkbox-error",
        key: this.props.name + '-error'
      }, messages.join("<br/>"));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return _react["default"].createElement("div", {
        style: _objectSpread({}, {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative'
        }, {}, this.props.style)
      }, _react["default"].createElement("div", {
        className: "squaredTwo",
        style: {
          margin: 0,
          minWidth: 20,
          maxWidth: 20,
          height: 20
        }
      }, _react["default"].createElement("input", {
        type: "checkbox",
        id: this.props.id,
        name: this.props.name,
        checked: this.props.value,
        onChange: function onChange() {
          return _this4._toggleValue();
        }
      }), _react["default"].createElement("label", {
        htmlFor: this.props.htmlFor,
        style: {
          width: 12,
          height: 12,
          top: 0,
          left: 0,
          margin: 0
        }
      })), _react["default"].createElement("label", {
        htmlFor: this.props.htmlFor,
        style: {
          cursor: 'pointer',
          color: 'white',
          fontWeight: 'lighter',
          fontSize: 14,
          paddingLeft: 10,
          marginBottom: 0
        }
      }, this.props.labelText));
    }
  }]);

  return AppCheckboxInput;
}(_react.Component);

exports["default"] = AppCheckboxInput;

_defineProperty(AppCheckboxInput, "defaultProps", void 0);

AppCheckboxInput.defaultProps = {
  onChange: function onChange(value) {},
  style: {}
};